import queryVirusTrip     from './query-virus-trip.js';
import queryUserVirusTrip from './query-user-virus-trip.js';
import queryVirusTripById from './query-virus-trip-by-id.js';

export default { queryVirusTrip, queryUserVirusTrip, queryVirusTripById };



// WEBPACK FOOTER //
// ./src/projects/virusTrip/service/index.js